// extracted by mini-css-extract-plugin
export default {"container":"OrdersTable_container__xPNYq","pointerCursor":"OrdersTable_pointerCursor__l-3Mk","status":"OrdersTable_status__aI6Pd"};